<!--
  导入
-->
<template>
  <span style="margin-right: 5px" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button
      :type="btnType"
      :icon="btnIcon"
      @click="dialogVisible = true"
      :class="btnClass"
      :size="btnSize"
    >
      {{ btnName }}
    </el-button>

    <!-- 提示导入 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :fullscreen="false"
    >
      <div class="com-import-body">
        <div class="alert-body" v-if="!regNull(alertTitle)">
          <el-alert
            :title="alertTitle"
            :type="alertType"
            :description="alertDesc"
            :show-icon="alertShowIcon"
            :closable="alertShowClosable"
          >
          </el-alert>
        </div>
        <div class="dialog-body">
          <!-- 第一步：下载模板 -->
          <div class="step-item">
            <div class="step-title">
              <span class="step-num">第 1 步</span>下载模板
            </div>

            <template
              v-if="
                !regNull(SemsterName) ||
                !regNull(ClassName) ||
                !regNull(CourseName)
              "
            >
              <div class="step-desc">
                根据当前页面的筛选条件
                <div class="filter-info">
                  {{ !regNull(SemsterName) ? "学期：" + SemsterName : "" }}
                  {{ !regNull(ClassName) ? " | 班级：" + ClassName : "" }}
                  {{ !regNull(CourseName) ? " | 课程：" + CourseName : "" }}
                </div>
                点击「下载模板」按钮，下载包含对应学生名单的模板。
              </div>

              <div class="btn-body">
                <el-button
                  size="small"
                  type="primary"
                  @click="onDownload"
                  class="btnSubSubmit"
                  >下载模板</el-button
                >
              </div>
            </template>
            <template v-else>
              <div class="step-desc">
                请先点击「下载模板」按钮进行模板的下载。
              </div>
              <div class="btn-body">
                <a :href="templatePath" target="_blank" class="aLinkBtn">
                  下载模板
                </a>
              </div>
            </template>
          </div>

          <!-- 第二步：上传文件 -->
          <div class="step-item mt-5">
            <div class="step-title">
              <span class="step-num">第 2 步</span>上传文件
            </div>
            <div class="step-desc">
              在模板中填写好信息内容后，点击「<b>上传文件</b>」按钮选择整理好的文档，再点击「<b>确定</b>」完成导入。
            </div>
            <!-- 上传文件按钮 + 原生文件输入-->
            <div v-if="!regNull(uploadPath)">
              <el-upload
                ref="import"
                class="upload-demo"
                :action="uploadPath"
                :limit="uploadFileCount"
                :before-upload="beforeUpload"
                :file-list="fileList"
                :auto-upload="false"
                :http-request="uploadFile"
                :on-change="handleChange"
                :before-remove="beforeRemove"
                :on-exceed="handleExceed"
              >
                <div class="btn-body ml-0">
                  <el-button size="small" type="primary" class="btnSubSubmit"
                    >上传文件</el-button
                  >
                </div>
              </el-upload>
              <div class="btn-desc">
                <div slot="tip" class="el-upload__tip">
                  只允许上传一个xls或xlsx格式的文件，且不超过{{ tipSize }}M
                </div>
              </div>
            </div>
            <div v-else class="err-box">
              请联系管理员，提供上传模板的路径，参数名：path
            </div>
          </div>
        </div>

        <!--弹出框内容-->
      </div>
      <!--弹出框内容-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitUpload()"
          :disabled="regNull(uploadPath)"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 错误原因 -->
    <el-dialog
      :title="dialogTitleErr"
      :visible.sync="dialogVisibleErr"
      width="60%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :fullscreen="false"
    >
      <template v-if="regNull(dialogInfoErr)">
        <el-table
          :data="itemDataErr"
          stripe
          class="elTableData"
          border
          height="500"
        >
          <el-table-column label="行号" class="elColumn" width="160">
            <template slot-scope="scope">
              第 {{ scope.row.index }} 行
            </template>
          </el-table-column>
          <el-table-column
            prop="reason"
            label="错误原因"
            class="elColumn"
          ></el-table-column>
        </el-table>
      </template>
      <template v-else>
        <div class="err-box">
          {{ dialogInfoErr }}
        </div>
      </template>
    </el-dialog>
  </span>
</template>

<script>
export default {
  props: {
    //模板路径
    template: {
      type: String,
      default: "",
    },
    //上传路径
    path: {
      type: String,
      default: null,
    },
    // 弹出框标题
    title: {
      type: String,
      default: "导入",
    },
    // 导入按钮显示名
    btnName: {
      type: String,
      default: "导入",
    },
    // 导入按钮样式 特殊样式请看下方<style>
    btnClass: {
      type: String,
      default: "",
    },
    // 按钮图标，基于ELEMENT图标
    btnIcon: {
      type: String,
      default: "el-icon-upload2",
    },
    params: {
      type: Object,
      default: null,
    },
    // 导入按钮尺寸
    btnSize: {
      type: String,
      default: "",
    },
    // 导入按钮颜色类型
    btnType: {
      type: String,
      default: "info",
    },
    // 学期
    SemsterName: {
      type: String,
      default: null,
    },
    // 班级
    ClassName: {
      type: String,
      default: null,
    },
    // 课程
    CourseName: {
      type: String,
      default: null,
    },
    // 导入提示标题
    alertTitle: {
      type: String,
      default: null,
    },
    // 导入提示类型，默认警告
    alertType: {
      type: String,
      default: "warning",
    },
    // 导入提示图标是否显示，默认显示
    alertShowIcon: {
      type: Boolean,
      default: true,
    },
    // 导入提示文案
    alertDesc: {
      type: String,
      default: null,
    },
    // 导入提示关闭按钮是否显示,默认不显示
    alertShowClosable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fullscreenLoading: false,
      // 上传文件数量
      uploadFileCount: 1,
      //弹出框属性
      dialogVisible: false,
      //上传组件地址
      fileList: [],
      //上传路径
      uploadPath: null,
      //模板路径
      templatePath: null,

      tipSize: webUploadFileSize(),

      // 导入提示错误
      dialogVisibleErr: false,
      dialogTitleErr: null,
      dialogInfoErr: null,
      itemDataErr: [],
    };
  },
  created() {
    let that = this;
    // 判断上传路径是否为空
    if (that.path != null && that.path.length > 0) {
      that.uploadPath = that.path;
    }
    // 判断模板路径是否为空
    if (that.template != null && that.template.length > 0) {
      // 模板放置至前端,文件夹名为public/templates,下载地址路径列如：/templates/成绩导入模板.xlsx
      that.templatePath = that.$ServerUrl() + that.template; //that.$ServerUrl() + that.template;
    }
  },
  computed: {
    /**
     * @description 监控上传API接口地址
     */
    comUploadPath: function () {
      return this.uploadPath;
    },
  },
  watch: {
    // 监控传过来的接口值是否变化
    path: function (newValue, oldValue) {
      this.uploadPath = newValue;
    },
  },
  methods: {
    handleExceed(files, fileList) {
      // let that=this;
      // that.fileList = fileList.slice(0);
      // warning(that,`当前限制选择 ${that.uploadFileCount} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {},
    handleChange(file, fileList) {
      // // this.$refs.import.clearFiles();
    },
    /**
     * @description 关闭弹出框
     * @param {Object} done
     */
    handleClose(done) {
      let that = this;
      this.dialogVisible = false;
    },
    /**
     * @description 确认导入按钮事件
     */
    submitUpload() {
      let that = this;
      that.$refs.import.submit();
    },
    /**
     * @description 通过接口下载模板
     */
    onDownload() {
      let that = this;
      that.$emit("download");
    },
    /**
     * @description 开始上传文件
     * @param {Object} content
     */
    uploadFile(content) {
      let that = this;
      that.dialogInfoErr = null;
      // 接收上传文件的后台地址
      var url = that.uploadPath;
      let files = new FormData();
      files.append("file", content.file);
      if (that.params != null) {
        for (var it of that.params) {
          files.append(it, that.params[it]);
        }
      }
      that.fullscreenLoading = true;
      ajaxUpload(that, url, files, function (r) {
        that.fullscreenLoading = false;

        if (!regNull(r)) {
          if (r.data.success != false) {
            if (r.data.success >= 0 || r.data.success == true) {
              if (r.data.result == true) {
                var it = {
                  result: r.data.result, //导入结果
                  total: r.data.total, //导入记录总数
                  success: r.data.success, //导入成功记录数
                };
                that.$refs.import.abort(content.file);
                that.fileList.splice(that.fileList.indexOf(content.file), 1);
                that.dialogVisible = false;
                that.$emit("onImportSuccess", it);
              } else {
                var it = {
                  result: r.data.result, //导入结果
                  total: r.data.total, //导入记录总数
                  error: r.data.error, //导入错误原因
                  message: r.data.message,
                };
                that.$refs.import.abort(content.file);
                that.fileList.splice(that.fileList.indexOf(content.file), 1);
                that.dialogVisible = false;

                if (!regNullArray(it.error)) {
                  that.dialogVisibleErr = true;
                  that.itemDataErr = it.error;
                  that.dialogTitleErr = it.message;
                }

                that.$emit("onImportSuccess", it);
              }
            } else {
              var it = {
                result: r.data.result, //导入结果
                total: r.data.total, //导入记录总数
                error: r.data.error, //导入错误原因
                message: r.data.message,
              };
              if (!regNullArray(it.error)) {
                that.dialogVisibleErr = true;
                that.itemDataErr = it.error;
                that.dialogTitleErr = it.message;
              }
              that.$refs.import.abort(content.file);
              that.fileList.splice(that.fileList.indexOf(content.file), 1);
              that.dialogVisible = false;
              that.$emit("onImportSuccess", it);
            }
          } else {
            var it = {
              result: false,
              message: r.data.message,
            };
            that.dialogVisibleErr = true;
            that.itemDataErr = r.data.error;
            that.dialogTitleErr = r.data.message;
            that.$refs.import.abort(content.file);
            that.fileList.splice(that.fileList.indexOf(content.file), 1);
            that.dialogVisible = false;
            that.$emit("onImportSuccess", it);
          }
        } else {
          var it = {
            result: false,
            message: r.message,
          };
          that.dialogTitleErr = "导入失败";
          that.dialogVisibleErr = true;
          that.dialogInfoErr = "导入失败原因：" + r.message;
          that.$refs.import.abort(content.file);
          that.fileList.splice(that.fileList.indexOf(content.file), 1);
          that.dialogVisible = false;
          that.$emit("onImportSuccess", it);
        }
      });
    },
    /**
     * @description 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
     * @param {Object} file
     */
    beforeUpload(file) {
      let that = this;
      // 检查文件后缀名
      const fileName = file.name;
      const ext = fileName
        .substring(fileName.lastIndexOf(".") + 1)
        .toLowerCase();
      const isXlsByExt = ext === "xls" || ext === "xlsx";
      // 检查文件MIME类型
      // const isXlsByType =
      //   file.type === "application/vnd.ms-excel" ||
      //   file.type ===
      //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      //   file.type === "application/wps-office.xlsx" ||
      //   file.type === "application/wps-office.xls";
      // const isXls = isXlsByExt || isXlsByType;
      if (!isXlsByExt) {
        warning(that, "仅支持xls和xlsx格式的文件上传!");
      }
      const isLt10M = file.size / 1024 / 1024 < webUploadFileSize();
      if (!isLt10M) {
        warning(that, "上传文件大小不能超过 " + webUploadFileSize() + "M!");
      }
      return isXlsByExt && isLt10M;
    },
  },
};
</script>

<style lang="less">
// 无框按钮，一般应用在【更多操作】内
.btnClass_NoBorder {
  color: #409eff !important;
  border: none;
  background-color: inherit;
  font-size: 14px;
  text-align: left;
  padding: 0;
  &:hover {
    background-color: inherit;
  }
}

.boxBtnImport {
  background-color: transparent !important;
  border: none;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0 !important;
  left: 0;
  z-index: 100;
  width: 100%;
}
.com-import-body {
  .alert-body {
    padding-bottom: 30px;
  }
  .dialog-body {
    min-height: 200px;

    .el-upload {
      margin-left: 30px;
    }

    /* 步骤容器 */
    .step-item {
      margin-bottom: 28px;
    }
    .step-title {
      font-size: 16px;
      font-weight: 700;
      color: #1f2937;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
    }
    /* 步骤序号 */
    .step-num {
      display: inline-block;
      text-align: center;
      background: #e6a23c;
      color: #fff;
      width: 80px;
      border-radius: 5px;
      margin-right: 8px;
      padding: 2px 0px;
      font-size: 16px;
    }
    /* 说明文本 */
    .step-desc {
      font-size: 16px;
      line-height: 1.6;
      color: #303133;
      margin-left: 28px;
      margin-bottom: 16px;
    }
    .filter-info {
      margin: 8px 0;
      color: #409eff;
    }

    .btn-body {
      text-align: left;
      margin-left: 30px;
      .btnSubSubmit {
        width: 120px;
      }
    }
    .err-box {
      font-size: 16px;
      padding-left: 30px;
      color: #f56c6c;
    }
    .btn-desc {
      padding-left: 30px;
    }

    .aLinkBtn {
      width: 120px;
      cursor: pointer;
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      padding: 10px 15px;
      font-size: 12px;
      border-radius: 3px;
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      transition: 0.1s;
      font-weight: 500;
      &:hover {
        background-color: #66b2fe;
        border-color: #66b2fe;
      }
    }
  }
}
</style>
